import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import SearchOverlay from "@/components/feature/SearchOverlay";
import { navLinks, siteBrand } from "@/mocks/site";

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen || searchOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen, searchOpen]);

  return (
    <>
      <header
        className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-background-200/60 bg-background-50"
        }`}
      >
        <div className="mx-auto flex h-16 w-full max-w-content items-center justify-between px-4 md:h-[70px] md:px-6">
          <Link to="/" className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
              瓜
            </span>
            <span className="flex flex-col leading-tight">
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                {siteBrand.name}
              </span>
              <span className="hidden text-[11px] tracking-[0.18em] text-foreground-500 sm:block">
                深度复盘 · 时间线
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navLinks.map((link) => (
              <NavLink
                key={link.href}
                to={link.href}
                end={link.href === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? "bg-background-200 font-medium text-foreground-950"
                      : "text-foreground-600 hover:bg-background-100 hover:text-foreground-900"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-primary-300 hover:bg-background-100 hover:text-foreground-950"
              aria-label="搜索"
            >
              <i className="ri-search-line text-base"></i>
            </button>
            <Link
              to="/about#submit"
              className="hidden whitespace-nowrap rounded-md bg-foreground-900 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800 md:inline-flex"
            >
              线索投稿
            </Link>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
              aria-label="打开菜单"
              aria-expanded={menuOpen}
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-3-line text-lg"}></i>
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <nav className="mx-auto flex w-full max-w-content flex-col px-4 py-3" aria-label="移动导航">
              {navLinks.map((link) => (
                <NavLink
                  key={link.href}
                  to={link.href}
                  end={link.href === "/"}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `rounded-md px-3 py-3 text-sm transition-colors ${
                      isActive
                        ? "bg-background-200 font-medium text-foreground-950"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
              <Link
                to="/about#submit"
                onClick={() => setMenuOpen(false)}
                className="mt-2 rounded-md bg-foreground-900 px-3 py-3 text-center text-sm font-medium text-background-50"
              >
                线索投稿
              </Link>
            </nav>
          </div>
        ) : null}
      </header>

      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}